// Specifies the delimiter used to separate the parts of the sourceId
export const SourceIdPartDelimiter = ":";

export const SourceIdDelimiterRegularExpression: RegExp = /:/gi;
